export const enRequests = {
	application: "Application",
	requests: "Requests",
	costs: "Costs",
	time: "Time",
	companyId: "Company ID",
};
